module.exports = __webpack_public_path__ + "img/icon_todos_historial.352e9b9f.svg";